import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import SolutionsSection from './components/SolutionsSection';
import AdvantagesSection from './components/AdvantagesSection';
import FeaturedArticles from './components/FeaturedArticles';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '悠宝三岁官方首页',
  description: '专为3岁宝宝打造的成长方案，涵盖营养、早教、习惯培养一站式科学育儿体系',
  about: {
    '@type': 'Organization',
    name: '悠宝三岁',
    description: '专为3岁儿童设计的综合成长解决方案',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="首页"
        description="悠宝三岁是专为3岁儿童设计的综合成长解决方案，涵盖营养、早教、习惯培养等核心需求。科学陪伴宝宝度过关键发育阶段。"
        keywords="悠宝三岁,悠宝三岁早教方案,悠宝三岁营养成长,3岁宝宝发育关键期,三岁儿童成长计划"
        schema={homeSchema}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <SolutionsSection />
        <AdvantagesSection />
        <FeaturedArticles />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}